import React from 'react'
import { useTheme } from '@mui/material/styles'

interface InfoBubbleIconProps {
  color?: string
  error?: boolean
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const InfoBubbleIcon: React.FC<InfoBubbleIconProps> = ({
  color = '#666',
  error,
  gradient,
  width = 16,
  height = 16,
  alt = 'Info bubble icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }
  const theme = useTheme()

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 16 16'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : error ? theme.palette.error.dark : color}
        fillRule='evenodd'
        d='M14.75 8a6.75 6.75 0 11-13.5 0 6.75 6.75 0 0113.5 0zM16 8A8 8 0 110 8a8 8 0 0116 0zm-7.318 5.5V6.656H7.318V13.5h1.364zM7.288 3.31A.982.982 0 007 4.023c0 .278.096.521.288.728.202.196.44.294.712.294a.939.939 0 00.697-.294C8.899 4.544 9 4.3 9 4.023a.957.957 0 00-.303-.713A.917.917 0 008 3a.964.964 0 00-.712.31z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default InfoBubbleIcon
